import React from 'react';

function Logo() {
  return (
    <svg width="291" height="26" viewBox="0 0 291 26" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient x1="50%" y1="99.425%" x2="50%" y2="-6.113%" id="a">
          <stop stopColor="#8C1436" offset="0%" />
          <stop stopColor="#8C1436" stopOpacity=".99" offset="1%" />
          <stop stopColor="#881B34" stopOpacity=".46" offset="49%" />
          <stop stopColor="#851F33" stopOpacity=".13" offset="83%" />
          <stop stopColor="#842132" stopOpacity="0" offset="100%" />
        </linearGradient>
      </defs>
      <g fillRule="nonzero" fill="none">
        <path fill="#FFF" d="M278.566 8.08H196.61l11.524 13.18h82.137-.044" />
        <path
          d="M231.308 11.198l-2.16 1.43h-5.178c-1.606-.038-3.208.17-4.75.62-.974.213-1.84.767-2.442 1.563-.35.61-.124 1.127.698 1.476 1.194.44 2.465.63 3.736.562.947-.004 1.892-.087 2.825-.247l.462-.81h-2.342l.73-1.26h5.842l-1.733 2.994s-1.576.36-2.667.495c-1.34.167-2.69.253-4.04.258-2.17.112-4.338-.225-6.37-.99-1.434-.66-1.854-1.505-1.26-2.533.59-1.028 1.99-1.883 4.197-2.566 2.478-.7 5.045-1.033 7.62-.992h6.83zM241.38 11.187c2.083-.13 4.165.237 6.078 1.07 1.298.705 1.673 1.53 1.126 2.475-.548.946-1.89 1.775-4.03 2.488-2.352.73-4.806 1.084-7.27 1.046-2.083.127-4.167-.232-6.09-1.046-1.32-.698-1.695-1.527-1.124-2.488.57-.96 1.913-1.79 4.03-2.487 2.354-.738 4.813-1.095 7.28-1.058zm-3.263 5.628c1.365.024 2.725-.17 4.03-.574.905-.225 1.702-.763 2.25-1.52.36-.63.19-1.124-.518-1.53-1.066-.453-2.222-.65-3.377-.573-1.37-.026-2.733.168-4.04.574-.91.227-1.707.77-2.252 1.53-.36.63-.18 1.127.53 1.52 1.06.474 2.217.694 3.377.642v-.067zM260.694 16.815l-1.835 1.27h-10.636l3.984-6.898h3.444l-3.253 5.628M276.158 11.187l-1.992 1.272h-5.785l-.888 1.54h5.56l-2.015 1.26h-4.3l-1.63 2.838h-3.468l3.972-6.91"
          fill="#000"
        />
        <path fill="#AE252F" d="M196.024 8.08l11.637 13.18h3.04L198.995 8.08" />
        <path
          fill="#FFF"
          d="M62.486 8.42h-25.3l2.273 2.385h7.135v10.602h6.482V10.805h7.125M65.548 8.42L55.07 21.383h6.83l1.948-2.566h11.638l2.172 2.566h6.978L73.043 8.42h-7.495zm0 8.147l3.815-5.042 4.187 5.042h-8.002zM79.492 10.805h7.136v10.602h6.47V10.805h7.137l2.273-2.386h-25.29M123.622 14h-12.954V8.42h-6.47v12.987h6.47v-4.885h12.954v4.885h6.483V8.42h-6.483M142.45 8.42l-10.477 12.964h6.854l1.947-2.566h11.615l2.138 2.566h6.978L149.958 8.42h-7.507zm0 8.147l3.862-5.042 4.187 5.042h-8.05zM179.412 8.42h-25.29l2.274 2.385h7.136v10.602h6.47V10.805h7.137M190.554 8.42h-7.507L172.57 21.383h6.853l1.947-2.566h11.615l2.14 2.566h6.977L190.554 8.42zm-7.473 8.147l3.816-5.042 4.187 5.042h-8.002z"
        />
        <ellipse fill="#FFF" opacity=".5" cx="12.133" cy="11.39" rx="12.133" ry="11.39" />
        <path
          d="M12.133.203C5.55.203.203 5.223.203 11.39S5.55 22.577 12.12 22.577c6.574 0 11.92-5.02 11.92-11.187C24.04 5.222 18.705.203 12.133.203z"
          fill="#B1132F"
        />
        <ellipse fill="url(#a)" style={{ mixBlendMode: 'multiply' }} cx="12.133" cy="11.39" rx="11.469" ry="10.771" />
        <path
          d="M29.79 9.578l2.016-2.026h-6.45V6.36h-3.32v1.203h-8.114V6.36h-3.31v1.203h-6.46L6.18 9.59h4.433v.832H6.46l2.026 1.958h2.127v13.506l3.31-.574V12.38h8.125v12.932l3.31.585V12.38h2.126l2.026-2.026h-4.153v-.776h4.434zm-15.868 0h3.028v.833h-3.028V9.58zm8.126.833h-3.016V9.58h3.005l.01.833z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default Logo;



// WEBPACK FOOTER //
// ./src/layout/Logo.js